import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { PriceSource } from '../schemas/pricing-rules';

const STYLES: Record<PriceSource, string> = {
  store: 'bg-primary/10 text-primary border-transparent',
  price_list: 'bg-info/15 text-info border-transparent',
  converted: 'bg-warning/20 text-warning-foreground border-transparent dark:text-warning',
  base: 'bg-secondary text-secondary-foreground border-transparent',
  none: 'border-dashed text-muted-foreground',
};

/** Where the effective price comes from: Store / Price list / Converted / Base, or no rate yet. */
export function PriceSourceBadge({
  source,
  label,
  className,
}: {
  source: PriceSource;
  /** Replaces the short word, where there is room to say what it means. */
  label?: string;
  className?: string;
}) {
  const { t } = useTranslation('storeCatalog');
  return (
    <Badge variant="outline" className={cn(STYLES[source], className)}>
      {label ?? t(`pricing.source.${source}`)}
    </Badge>
  );
}
